<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="py-0">
                <v-text-field
                        outlined
                        v-model="text"
                        label="Text"
                ></v-text-field>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="ma-2"
                       color="primary"
                       @click="onPressSave">Add
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "utils-popup-input-text",
    props: {},
    components: {},
    data: () => ({
        dialog: false,
        text: "",
        onComplete:null,
    }),
    computed: {
    },
    methods: {
        show(oldValue, onComplete) {
            this.text = oldValue
            this.dialog = true
            this.onComplete = onComplete
        },
        hide() {
            this.dialog = false
        },
        onClose() {
            this.hide()
        },
        onPressSave() {
            this.dialog = false
            this.onComplete(this.text)
        },
    },
}
</script>

<style scoped>

</style>